import { Component, OnInit, OnDestroy, Input } from '@angular/core';

import { Subscription } from 'rxjs';

import { ActivityBlockingService } from '../services/activity-blocking.service';
import { AuthService } from '../authentication/auth.service';
import { BrowserProviderService } from '@shared/services/browser-provider.service';
import { SharedSettings } from '@shared/models/shared-settings';
import { Message } from 'primeng/api';
import { MessageService } from "@shared/services/message-service"

@Component({
    selector: 'theme-root',
    templateUrl: './theme.component.html',
    styleUrls: ['./theme.component.scss']
})
export class ThemeComponent implements OnInit, OnDestroy {

    @Input() buildNumber: string;

    topbarMenuActive: boolean;

    overlayMenuActive: boolean;

    staticMenuDesktopInactive: boolean;

    staticMenuMobileActive: boolean;

    layoutMenuScroller: HTMLDivElement;

    menuClick: boolean;

    topbarItemClick: boolean;

    activeTopbarItem: any;

    resetMenu: boolean;

    menuHoverActive: boolean;

    showLoadingOverlay: boolean;

    authMessage: { summary: string, detail: string} = null;

    subscriptions: Subscription[];

    isDebugging = false;
    isPropak = false;
    isTestEnvironment = false;

    constructor(
        private activityService: ActivityBlockingService,
        private authService: AuthService,
        private settings: SharedSettings,
        private messageService: MessageService,
        private browser: BrowserProviderService) {

        window["toggleDebug"] = () => {
            this.isDebugging = !this.isDebugging;

            if (!this.isDebugging) {
                localStorage.removeItem('debugsettings');
                this.isPropak = this.browser.GetLocation().hostname.endsWith('propak.com');
                this.isTestEnvironment = !this.settings.isProduction;
            }
        }

        window["showToast"] = (msg: Message) => this.messageService.add(msg);

        this.isDebugging = this.browser.GetLocation().hostname === 'localhost';
        this.isPropak = this.browser.GetLocation().hostname.endsWith('propak.com');
        this.isTestEnvironment = !this.settings.isProduction;

        if (this.isDebugging && localStorage.getItem('debugsettings')) {
            const settings = JSON.parse(localStorage.getItem('debugsettings'));
            this.isPropak = settings.isPropak;
            this.isTestEnvironment = settings.isTestEnvironment;
        }
    }

    ngOnInit(): void {
        this.subscriptions = [
            this.activityService.IsBusy.subscribe(busy => {
                setTimeout(() => { this.showLoadingOverlay = busy; });
            }),
            this.authService.AuthMessage.subscribe(msg => {
                setTimeout(() => { this.authMessage = msg; });
            })
        ];
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => { s.unsubscribe(); });
    }

    onSettingsChange(): void {
        localStorage.setItem('debugsettings', JSON.stringify({
            isPropak: this.isPropak,
            isTestEnvironment: this.isTestEnvironment
        }));
    }

    onLayoutClick(): void {
        if (!this.topbarItemClick) {
            this.activeTopbarItem = null;
            this.topbarMenuActive = false;
        }

        if (!this.menuClick) {
            if (this.overlayMenuActive || this.staticMenuMobileActive) {
                this.hideOverlayMenu();
            }

            this.menuHoverActive = false;
        }

        this.topbarItemClick = false;
        this.menuClick = false;
    }

    onMenuButtonClick(event: MouseEvent): void {
        this.menuClick = true;
        this.topbarMenuActive = false;

        if (this.isDesktop()) {
            this.staticMenuDesktopInactive = !this.staticMenuDesktopInactive;
        } else {
            this.staticMenuMobileActive = !this.staticMenuMobileActive;
        }

        event.preventDefault();
    }

    isMobile(): boolean {
        return window.innerWidth < 1025;
    }

    isDesktop(): boolean {
        return window.innerWidth > 1024;
    }

    isTablet(): boolean {
        const width = window.innerWidth;
        return width <= 1024 && width > 640;
    }

    hideOverlayMenu(): void {
        this.overlayMenuActive = false;
        this.staticMenuMobileActive = false;
    }

    onCloseMessage(event: { message: Message }): void {
        this.messageService.removeMessage(event.message);
    }
}
